import { ConfigConstants } from '../../config/config-constants';
import { ODataObject } from '../../interfaces/odata-model.interface';
import {
    BooleanModelOptions,
    BooleanModelOptionsFromJson,
    JsonBooleanModelOptions,
} from '../options/boolean-model-options';
import { PrimitiveModel } from './primitive.model';

export class BooleanModel extends PrimitiveModel {
    public constructor(
        name: string,
        public value = false,
        public options = new BooleanModelOptions(),
    ) {
        super(name, value, options);
        if (options.defaultValue) {
            this.value = options.defaultValue;
        }
    }

    public getOutModel(): ODataBooleanOutModel {
        const outModel: ODataBooleanOutModel = {};

        if (this.options.isBinaryValue) {
            outModel[this.name] = this.value ? ConfigConstants.sapTrueBinaryValue : ConfigConstants.sapFalseBinaryValue;
        } else {
            outModel[this.name] = this.value ? ConfigConstants.sapTrue : ConfigConstants.sapFalse;
        }

        return outModel;
    }

    public static fromODataModel(name: string, value: '' | 'X', options: BooleanModelOptions): BooleanModel {
        return new BooleanModel(name, value === ConfigConstants.sapTrue, options);
    }
}

export class BooleanModelFromJson extends BooleanModel {
    public constructor(data: JsonBooleanModel) {
        super(data.name, data.value, new BooleanModelOptionsFromJson(data.options));
    }
}

export interface JsonBooleanModel {
    name: string;
    value: boolean;
    options: JsonBooleanModelOptions;
}

export interface ODataBooleanOutModel extends ODataObject {
    [key: string]: '' | 'X' | 1 | 0;
}
